module.exports = __webpack_public_path__ + "img/tour-open.d42efb2a.svg";